import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Remove Stroke
 */

export default function RemoveStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M6 2V1H10V2H6ZM5 2V0.5C5 0.223858 5.22386 0 5.5 0H10.5C10.7761 0 11 0.223858 11 0.5V2H12.5H15C15.2761 2 15.5 2.22386 15.5 2.5C15.5 2.77614 15.2761 3 15 3H13V15.5C13 15.7761 12.7761 16 12.5 16H3.5C3.22386 16 3 15.7761 3 15.5V3H1C0.723858 3 0.5 2.77614 0.5 2.5C0.5 2.22386 0.723858 2 1 2H3.5H5ZM10.5 3H5.5H4V15H12V3H10.5ZM8 5.5C8.27614 5.5 8.5 5.72386 8.5 6L8.5 12C8.5 12.2761 8.27614 12.5 8 12.5C7.72386 12.5 7.5 12.2761 7.5 12L7.5 6C7.5 5.72386 7.72386 5.5 8 5.5ZM10.5 6C10.5 5.72386 10.2761 5.5 10 5.5C9.72386 5.5 9.5 5.72386 9.5 6V12C9.5 12.2761 9.72386 12.5 10 12.5C10.2761 12.5 10.5 12.2761 10.5 12V6ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6L6.5 12C6.5 12.2761 6.27614 12.5 6 12.5C5.72386 12.5 5.5 12.2761 5.5 12L5.5 6C5.5 5.72386 5.72386 5.5 6 5.5Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
